import type { ReactNode } from "react";

interface Props {
  title: string;
  children: ReactNode;
}

// 认证页面共用卡片布局
export function AuthCard({ title, children }: Props) {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="card w-full max-w-sm p-6">
        {/* <h1 className="text-xl font-bold text-center mb-1">看股票</h1>
        <p className="text-center flat text-13px mb-5">基于技术指标智能筛选股票机会</p> */}
        <h2 className="text-lg font-semibold text-center mb-5">{title}</h2>
        {children}
      </div>
    </div>
  );
}
